<h1>{{show.name}}</h1>
<h4>Status: {{show.status | titlecase}} | Language: {{show.language | titlecase}}</h4>
<p>{{show.summary | htmlstripper}}</p>

<mat-form-field>
  <mat-label>Filter</mat-label>
  <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
</mat-form-field>

<table mat-table [dataSource]="episodes" class="mat-elevation-z8">

  <ng-container matColumnDef="number">
    <th mat-header-cell *matHeaderCellDef>#</th>
    <td mat-cell *matCellDef="let episode">{{episode.fullNumber}}</td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Title</th>
    <td mat-cell *matCellDef="let episode">{{episode.name}}</td>
  </ng-container>

  <ng-container matColumnDef="aired">
    <th mat-header-cell *matHeaderCellDef>Aired</th>
    <td mat-cell *matCellDef="let episode">{{episode.airDate | date: 'yyyy/MMM/dd'}}</td>
  </ng-container>

  <ng-container matColumnDef="summary">
    <th mat-header-cell *matHeaderCellDef>Plot</th>
    <td mat-cell *matCellDef="let episode">{{episode.summary | htmlstripper | shorten: 250}}</td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="tableHeaders"></tr>
  <tr mat-row *matRowDef="let row; columns: tableHeaders;"></tr>
</table>
